import { RefObject } from 'react';
import { useShowScrollArrowOnContainer } from '../../../hooks/useShowScrollArrow';
import { SquareArrowDown } from 'lucide-react';

export function ScrollDownArrow({
  containerRef,
  bottomValue
}: {
  containerRef: RefObject<HTMLElement | null>;
  bottomValue: string;
}) {
  const showArrow = useShowScrollArrowOnContainer(containerRef);
  if (!showArrow) return null;

  return (
    <div
      id="scrollDownArrow"
      className="sticky z-[500] flex justify-end animate-pulse px-4"
      style={{ bottom: bottomValue, pointerEvents: 'none' }}
    >
      <SquareArrowDown
        color="#56dac5"
        style={{ pointerEvents: 'all' }}
        className="cursor-pointer"
        size={36}
        onClick={() => {
          if (containerRef.current) {
            containerRef.current.scrollBy({
              top:
                containerRef.current.scrollTop +
                containerRef.current.clientHeight,
              behavior: 'smooth'
            });
          }
        }}
      />
    </div>
  );
}
